function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameHud2Template = require('./game-hud2.template');
var GameHUD2 = /*#__PURE__*/function () {
  function GameHUD2(app, mod) {
    _classCallCheck(this, GameHUD2);
    this.app = app;
    this.mod = mod;
    this.drag_bound = false;
    this.esc_bound = false;
    this.back_button_callback = null;
    this.show_cardbox_on_hover = 1;

    //
    // Selector for an element in the game's own layout. When set, the HUD is
    // docked inside it (in normal flow, not draggable) instead of floating
    // over the board, so the game's CSS controls where it sits on each screen.
    //
    this.container = null;
    this.hud_popup_timeout = null;
    this.hud_popup_hide_timeout = null;
  }
  return _createClass(GameHUD2, [{
    key: "render",
    value: function render() {
      if (!this.mod.browser_active) {
        return;
      }
      if (!document.getElementById('game-hud2')) {
        this.app.browser.addElementToDom(GameHud2Template());
        this.drag_bound = false;
      }
      var hud = document.getElementById('game-hud2');
      if (!hud) {
        return;
      }
      var dock = this.container ? document.querySelector(this.container) : null;
      if (dock) {
        if (hud.parentElement !== dock) {
          dock.appendChild(hud);
        }
        hud.classList.add('docked');
        hud.style.zIndex = '';
      } else {
        hud.classList.remove('docked');
        // Overlays set hud_above_overlay so card selection stays above them.
        // Later HUD updates all come through render(), which would otherwise
        // put the HUD back at 50, under the overlay.
        if (this.mod && this.mod.hud_above_overlay) {
          this.raiseAboveOverlays(hud);
        } else {
          hud.style.zIndex = 50;
        }
      }
      this.attachEvents();
    }
  }, {
    key: "isDocked",
    value: function isDocked() {
      var hud = document.getElementById('game-hud2');
      return !!hud && hud.classList.contains('docked');
    }
  }, {
    key: "pullToFront",
    value: function pullToFront() {
      this.render();
      var hud = document.getElementById('game-hud2');
      if (!hud || this.isDocked()) {
        return;
      }
      this.raiseAboveOverlays(hud);
    }
  }, {
    key: "raiseAboveOverlays",
    value: function raiseAboveOverlays(hud) {
      var max_z = 50;
      document.querySelectorAll('.saito-overlay, .saito-overlay-backdrop').forEach(function (el) {
        var z = parseInt(el.style.zIndex, 10);
        if (z > max_z) {
          max_z = z;
        }
      });
      hud.style.zIndex = max_z + 1;
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var hud = document.getElementById('game-hud2');
      if (!hud || this.drag_bound) {
        return;
      }
      this.drag_bound = true;
      hud.addEventListener('selectstart', function (e) {
        e.preventDefault();
      });
      hud.addEventListener('mousedown', function (e) {
        if (e.button !== 0 || _this.isDocked()) {
          return;
        }
        if (e.target.closest('.hud-back-button, .hud-notice, a, input, textarea, button, select')) {
          return;
        }
        e.preventDefault();
        var click_el = e.target.closest('.option, .hud-menu li, .hud-visual-option, .hud-cards .card');
        var rect = hud.getBoundingClientRect();
        var start_x = e.clientX;
        var start_y = e.clientY;
        var orig_left = rect.left;
        var orig_top = rect.top;
        var dragged = false;
        var place = function place(dx, dy) {
          hud.style.left = orig_left + dx + 'px';
          hud.style.top = orig_top + dy + 'px';
          hud.style.right = 'auto';
          hud.style.bottom = 'auto';
          hud.style.marginLeft = '0px';
          hud.style.marginRight = '0px';
          hud.style.transform = 'none';
        };
        var on_move = function on_move(ev) {
          var dx = ev.clientX - start_x;
          var dy = ev.clientY - start_y;
          if (!dragged && Math.abs(dx) < 4 && Math.abs(dy) < 4) {
            return;
          }
          dragged = true;
          place(dx, dy);
        };
        var _on_up = function on_up() {
          document.removeEventListener('mousemove', on_move);
          document.removeEventListener('mouseup', _on_up);
          document.body.style.userSelect = '';
          if (!dragged && click_el) {
            click_el.click();
          }
        };
        document.body.style.userSelect = 'none';
        document.addEventListener('mousemove', on_move);
        document.addEventListener('mouseup', _on_up);
      });
      var hudnotice = hud.querySelector('.hud-notice');
      if (hudnotice) {
        hudnotice.onclick = function () {
          _this.hidePopup();
        };
      }
      if (!this.esc_bound) {
        this.esc_bound = true;
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape' && e.keyCode !== 27) {
            return;
          }
          if (!_this.back_button_callback) {
            return;
          }
          var t = e.target;
          if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          var cb = _this.back_button_callback;
          _this.hideBackButton();
          cb();
        });
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.hidePopup();
      document.querySelectorAll('#game-hud2').forEach(function (el) {
        el.style.display = 'none';
      });
      this.hideVisualMenu();
      this.back_button_callback = null;
    }
  }, {
    key: "hideVisualMenu",
    value: function hideVisualMenu() {
      var visual_menu = document.getElementById('hud-visual-menu');
      if (visual_menu) {
        visual_menu.innerHTML = '';
        visual_menu.className = 'hud-visual-menu';
        visual_menu.onclick = null;
      }
      var backdrop = document.getElementById('hud-visual-menu-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
    }
  }, {
    key: "showVisualMenuBackdrop",
    value: function showVisualMenuBackdrop() {
      var _this2 = this;
      var hud = document.getElementById('game-hud2');
      var visual_menu = document.getElementById('hud-visual-menu');
      if (!hud || !visual_menu) {
        return;
      }
      var backdrop = document.getElementById('hud-visual-menu-backdrop');
      if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.id = 'hud-visual-menu-backdrop';
        backdrop.className = 'hud-visual-menu-backdrop';
        hud.insertBefore(backdrop, visual_menu);
      }
      var swallow = function swallow(e) {
        e.stopPropagation();
      };
      backdrop.onmousedown = swallow;
      backdrop.onpointerdown = swallow;
      backdrop.onpointerup = swallow;
      backdrop.onmouseup = function (e) {
        swallow(e);
        _this2.hideVisualMenu();
      };
      backdrop.onclick = swallow;
    }
  }, {
    key: "hidePopup",
    value: function hidePopup() {
      clearTimeout(this.hud_popup_timeout);
      this.hud_popup_timeout = null;
      var hudnotice = document.querySelector('#game-hud2 .hud-notice');
      if (!hudnotice) {
        return;
      }
      hudnotice.classList.remove('show');
      clearTimeout(this.hud_popup_hide_timeout);
      this.hud_popup_hide_timeout = setTimeout(function () {
        if (!hudnotice.classList.contains('show')) {
          hudnotice.style.display = 'none';
        }
      }, 550);
    }
  }, {
    key: "showPopup",
    value: function showPopup() {
      var _this3 = this;
      var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.render();
      var hudnotice = document.querySelector('#game-hud2 .hud-notice');
      if (!hudnotice) {
        return;
      }
      clearTimeout(this.hud_popup_timeout);
      clearTimeout(this.hud_popup_hide_timeout);
      hudnotice.innerHTML = html || '';
      hudnotice.classList.remove('show');
      hudnotice.style.display = 'block';
      this.hud_popup_timeout = setTimeout(function () {
        hudnotice.classList.add('show');
        _this3.hud_popup_timeout = setTimeout(function () {
          _this3.hidePopup();
        }, timeout);
      }, 50);
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(status) {
      this.render();
      document.querySelectorAll('.hud-status, .zoom-overlay .status, .saito-overlay .status').forEach(function (el) {
        el.innerHTML = status;
      });
    }
  }, {
    key: "showBackButton",
    value: function showBackButton(callback) {
      var _this4 = this;
      this.render();
      this.back_button_callback = typeof callback === 'function' ? callback : null;
      var html = this.mod.back_button_html;
      if (!html) {
        html = "<i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>";
      }
      document.querySelectorAll('.hud-back-button').forEach(function (el) {
        el.innerHTML = html;
        el.style.display = 'inline-block';
        el.onclick = function (e) {
          e.stopPropagation();
          var cb = _this4.back_button_callback;
          _this4.hideBackButton();
          if (typeof cb === 'function') {
            cb();
          }
        };
      });
    }
  }, {
    key: "hideBackButton",
    value: function hideBackButton() {
      this.back_button_callback = null;
      document.querySelectorAll('.hud-back-button').forEach(function (el) {
        el.style.display = 'none';
        el.onclick = null;
      });
    }
  }, {
    key: "updateMenu",
    value: function updateMenu(options, callback) {
      var _this5 = this;
      this.render();
      if (!options) {
        options = [];
      }
      var html = '';
      if (options.length > 0) {
        html = '<ul>';
        for (var i = 0; i < options.length; i++) {
          var extra = options[i]["class"] ? " ".concat(options[i]["class"]) : '';
          html += "<li class=\"option".concat(extra, "\" id=\"").concat(options[i].id, "\">").concat(options[i].label, "</li>");
        }
        html += '</ul>';
      }
      var consumed = false;
      var choose = function choose(id) {
        if (consumed) {
          return;
        }
        consumed = true;
        document.querySelectorAll('.hud-menu .option, .zoom-overlay .controls .option, .saito-overlay .controls .option, #hud-visual-menu .hud-visual-option').forEach(function (item) {
          item.onclick = null;
        });
        callback(id);
      };
      document.querySelectorAll('.hud-menu, .zoom-overlay .controls, .saito-overlay .controls').forEach(function (el) {
        el.innerHTML = html;
        if (typeof callback === 'function') {
          el.querySelectorAll('.option').forEach(function (item) {
            item.onclick = function (e) {
              e.stopPropagation();
              choose(e.currentTarget.id);
            };
          });
        }
      });
      var visual_menu = document.getElementById('hud-visual-menu');
      if (!visual_menu) {
        return;
      }
      var visual_html = '';
      var visual_count = 0;
      for (var _i = 0; _i < options.length; _i++) {
        if (!options[_i].img) {
          continue;
        }
        visual_count++;
        var title = options[_i].title || options[_i].label;
        visual_html += "<div class=\"hud-visual-option\" id=\"hud-visual-".concat(options[_i].id, "\" style=\"--hud-option-img: url('").concat(options[_i].img, "')\"><div class=\"hud-visual-option-title\">").concat(title, "</div></div>");
      }
      visual_menu.innerHTML = visual_html;
      visual_menu.className = 'hud-visual-menu';
      visual_menu.onclick = null;
      if (visual_count > 0) {
        visual_menu.classList.add('m' + Math.min(visual_count, 9));
        this.showVisualMenuBackdrop();
        visual_menu.onclick = function (e) {
          if (e.target.closest('.hud-visual-option')) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          _this5.hideVisualMenu();
        };
        if (typeof callback === 'function') {
          visual_menu.querySelectorAll('.hud-visual-option').forEach(function (item) {
            item.onclick = function (e) {
              e.stopPropagation();
              var id = e.currentTarget.id;
              if (id.indexOf('hud-visual-') === 0) {
                id = id.substring('hud-visual-'.length);
              }
              choose(id);
            };
          });
        }
      } else {
        this.hideVisualMenu();
      }
    }
  }, {
    key: "updateCards",
    value: function updateCards(cards, callback) {
      this.render();
      var html = '';
      if (cards && cards.length > 0) {
        for (var i = 0; i < cards.length; i++) {
          var card_id = cards[i];
          html += "<div id=\"".concat(card_id, "\" class=\"card ").concat(card_id, "\">").concat(this.mod.returnCardImage(card_id), "</div>");
        }
      }
      document.querySelectorAll('.hud-cards').forEach(function (el) {
        el.innerHTML = html;
        if (typeof callback === 'function') {
          el.querySelectorAll('.card').forEach(function (card) {
            card.onclick = function (e) {
              callback(e.currentTarget.id);
            };
          });
        }
      });
      this.attachCardEvents();
    }
  }, {
    key: "attachCardEvents",
    value: function attachCardEvents() {
      if (!this.show_cardbox_on_hover) {
        return;
      }
      var cardbox = this.mod.cardbox;
      if (!cardbox) {
        return;
      }
      cardbox.render();
      document.querySelectorAll('.hud-cards .card').forEach(function (card) {
        card.onmouseover = function (e) {
          try {
            if (cardbox.cardbox_lock !== 1) {
              var popup = document.querySelector('.game-cardbox');
              if (popup) {
                popup.style.pointerEvents = 'none';
              }
              cardbox.show(e.currentTarget.id);
            }
          } catch (err) {
            console.error(err);
          }
        };
        card.onmouseout = function () {
          try {
            cardbox.hide();
          } catch (err) {
            console.error(err);
          }
        };
      });
    }
  }]);
}();
module.exports = GameHUD2;